var XPortal = XPortal || {};

XPortal.Sidebar = (function () {
    var vm = { refs: { $App: null, $SidebarNav: null, $NavGroups: null, $Navs: null } };
    var self =
    {
        $sidebar: $('.sidebar'),
        $body: $('body'),
        Init: function (selector, settingsObj) {
            XPortal.Sidebar.initDesktopMenu();
            XPortal.Sidebar.chekcSidebarHeight();
            XPortal.Sidebar.initMenuDesktopHover();
            XPortal.Sidebar.initMobileMenu();
            XPortal.Sidebar.initMobileMenuDoubleClick();
            XPortal.Sidebar.initMenuToggle();
            XPortal.GridSettings.GetSettingsLinks();
            $(window).on('resize', function () {
                XPortal.Sidebar.chekcSidebarHeight();
                XPortal.Sidebar.initMenuDesktopHover();
            });
        },
        initDesktopMenu: function () {
            var $menuBtnDesk = $('.desktop-menu-btn');
            var $menuBtnCompactBtn = $('.desktop-compact-menu-btn');
            var menuDesktopOpenClass = 'desktop-menu-opened';
            var menuDesktopCompactClass = 'desktop-menu-compact';
            var compactMenuParam = 'UMB-COMPACT-MENU';
            var menuOpenParam = 'UMB-MENU-OPEN';

            $menuBtnDesk.on('click', function (e) {
                e.preventDefault();
                XPortal.Sidebar.toggleSidebarState(menuOpenParam, menuDesktopOpenClass);
                self.$body.removeClass('desktop-menu-compact');
            });

            $menuBtnCompactBtn.on('click', function (e) {
                e.preventDefault();
                XPortal.Sidebar.toggleSidebarState(compactMenuParam, menuDesktopCompactClass);
                
                const maxSection = self.$body.find('.maximizible.maximize-mode-site.maximized');

                if(self.$body.hasClass('desktop-menu-compact') ) {
                    maxSection.css('left', 112);
                } else if (self.$body.hasClass('desktop-menu-opened')) {
                    maxSection.css('left', 266);
                }
            });

            XPortal.Sidebar.initSidebarState(menuOpenParam, menuDesktopOpenClass);
            XPortal.Sidebar.initSidebarState(compactMenuParam, menuDesktopCompactClass);

        },
        initMobileMenu: function () {
            XPortal.Sidebar.resetSideBarAllowClass();

            $('.mobile-menu-btn').click(function () {
                self.$body.toggleClass('mobile-menu-opened');
                $(window).trigger('resize.tabs');
            });

            $('.hide-menu-mobile').on('click', function (e) {
                self.hideMobile2dLevel();
            });
        },
        initMobileMenuDoubleClick: function () {
            var touchtime = 0;
            var openedClass = 'menu-opened';
            var forHoverClass = 'for-hover';
            var secondLevelOpenedClass = 'menu-second-level-opened';
            var activeClass = 'active-item';
            var allSelector = 'html.k-mobile .sidebar-menu > li > a';
            var allItemsSelector = 'html.k-mobile .sidebar-menu > li';
            $(allSelector).on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();

                var $this = $(this);
                var $item = $(this).parent();

                var $visibleUl = $this.parent().find('ul:visible');

                if (!$visibleUl.length || !$visibleUl.find('li:visible').length) {
                    XPortal.Sidebar.clearSidebar();
                    window.location.href = $this.attr('href');
                }

                if (!$item.hasClass(activeClass)) {
                    touchtime = 0;
                }

                $(allItemsSelector).removeClass(activeClass);
                $item.addClass(activeClass);

                if (touchtime == 0) {
                    touchtime = new Date().getTime();
                } else {
                    if (((new Date().getTime()) - touchtime) < 800) {
                        touchtime = 0;
                        XPortal.Sidebar.clearSidebar();
                        window.location.href = $this.attr('href');
                    } else {
                        touchtime = new Date().getTime();
                    }
                }

                if ($this.hasClass(openedClass)) {
                    $this.removeClass(openedClass);
                    self.$body.removeClass(forHoverClass);
                    self.$body.removeClass(secondLevelOpenedClass);
                }
                else {
                    $(allSelector).removeClass(openedClass);
                    $this.addClass(openedClass);
                    self.$body.addClass(forHoverClass);
                    setTimeout(function () {
                        self.$body.addClass(secondLevelOpenedClass);
                    }, 500);
                }
            });
        },
        hideMobile2dLevel: function () {
            $('.sidebar-menu > li').removeClass('active-item');
            $('.sidebar-menu > li > a').removeClass('menu-opened');
            self.$body.removeClass('menu-second-level-opened').addClass('for-hover');
        },
        clearSidebar: function () {
            self.$sidebar.addClass('no-transition');
            setTimeout(function () { self.$sidebar.addClass('strong-min-width'); }, 0);
        },
        initMenuToggle: function () {
            var $menu = $('.sidebar-menu > li > div');
            $menu.find('.open > a + div').show();
            $menu.find('.open > a').addClass('opened');

            $(document).on('click', '.sidebar-menu > li > div .arrow', function (e) {
                e.preventDefault();
                var $link = $(this).parent();
                if ($link.hasClass('opened')) {
                    $link.removeClass('opened');
                    $link.next().stop().slideUp(300);
                }
                else {
                    $link.addClass('opened');
                    $link.next().stop().slideDown(300).addClass('ie-fix');
                }
            });

            XPortal.Sidebar.resetSideBarAllowClass();
        },
        calculateSideBarTransform: function (menuFirstLevel) {
            var $menuFirstLevel = $(menuFirstLevel);
            var menuFirstLevelTop = $menuFirstLevel.offset().top;
            var windowScrolled = $(window).scrollTop();

            var menuFirstLevelHeight = $menuFirstLevel.height();;
            var $wrp = $menuFirstLevel.children().filter('.menu-lvl-wrp');
            $wrp.removeAttr('style');
            var wrpHeight = $wrp.outerHeight();
            var headerHeight = $('header').outerHeight();
            var sidebarHeight = $('.sidebar-nav').outerHeight();
            var footerTop = $('.footer').offset().top;
            var windowHeight = $(window).height();

            const liCount = $wrp.find('> ul > li').length;
            var wrpHeightMaxHeight = liCount > 4 ? 270 : 247;
            var top = menuFirstLevelTop - headerHeight + 12 - windowScrolled;

            // Top position to bottom of first level
            if (wrpHeight > wrpHeightMaxHeight && (menuFirstLevelTop + wrpHeightMaxHeight - menuFirstLevelHeight - headerHeight > sidebarHeight)) {
                top = menuFirstLevelTop - wrpHeightMaxHeight - menuFirstLevelHeight;
            } else if (menuFirstLevelTop + wrpHeight > footerTop) {
                top = menuFirstLevelTop - wrpHeight - menuFirstLevelHeight - windowScrolled;
            }

            // Wrapper is half-hidden when there is scroll on the page
            if ((top + wrpHeight + headerHeight) > windowHeight) {
                top = windowHeight - wrpHeight - headerHeight - 30;
            }
            
            $wrp.css({
                'top': top + 'px',
                'max-height': wrpHeightMaxHeight
            });
        },
        resetSideBarAllowClass: function () {
            self.$sidebar.removeClass('allow-hover');
        },
        updateMenuItem: function () {
            setTimeout(function () {
                $('.sidebar-menu > li  li > div > ul[data-mainlink].initialized').each(function (e, val) {
                    var mainlink = XPortal.Sidebar.findMainLinkforGrids($(val));
                    if (mainlink) {
                        if (mainlink.find("i.arrow").length == 0)
                            mainlink.append('<i class="arrow fa fa-angle-down"></i>');
                    }
                });
                XPortal.Utils.waitFor(function () {
                    var sdAllLink = $('.sidebar-menu > li  li [name="All"] , .sidebar-menu > li  li [name="undefined"]').map((i, el) => $(el).children('.close'));
                    if (!sdAllLink || !sdAllLink.length)
                        return false;
                    sdAllLink.each(function (e, el) {
                        $(el).removeClass('fa-recycle').removeClass('close');
                    });
                    return true;
                }, XPortal.Utils.waitFor, 100);

            }, 200)

        },
        findMainLinkforGrids: function (container) {
            if (container == null || container.length == 0) return;
            var mainLinkAttr = container.attr("data-mainLink");
            if (mainLinkAttr == null)
                return;
            return $("a." + mainLinkAttr);
        },
        isCompact: function () {
            var viewportName = XPortal.Utils.getViewportName();
            if (viewportName === 'md') return vm.refs.$App.hasClass('-sidebar-compact-tablet');
            if (viewportName === 'lg' || viewportName === 'xl') return vm.refs.$App.hasClass('-sidebar-compact-desktop');
            return vm.refs.$El.hasClass("is-compact");
        },
        initSidebarState: function (cookieName, toggleClass) {
            const menuCurrentState = Cookies.get(cookieName);
            if (menuCurrentState == "1") {
                self.$body.addClass(toggleClass);
            } else if (menuCurrentState == "0") {
                self.$body.removeClass(toggleClass);
            }
        },
        toggleSidebarState: function (cookieName, toggleClass) {
            self.$body.toggleClass(toggleClass);
            let finalized = false;
            const finalize = () => {
                if (finalized)
                    return;

                finalized = true;
                var menuCurrentState = self.$body.hasClass(toggleClass);
                var menuParamVal = menuCurrentState ? '1' : '0';

                Cookies.set(cookieName, menuParamVal, { path: '/', expires: 400 });
                console.log(`set ${cookieName} to ${menuCurrentState}`);
                $(window).trigger('resize');
            };

            self.$sidebar.one("transitionend", finalize);
            setTimeout(finalize, 500); // fallback in case transitionend doesn't fire
        },
        chekcSidebarHeight: function () {
            var $sidebarMenu = $('.sidebar-menu');
            var $header = $('.header');
            var $footer = $('.footer');
            if ($sidebarMenu.height() > ($(window).height() - $header.height() - $footer.height())) {
                self.$sidebar.addClass('sidebar_with-scroll');
            } else {
                self.$sidebar.removeClass('sidebar_with-scroll');
            }
        },
        initMenuDesktopHover: function () {
            if (XPortal.Utils.getViewportWidth() < 768) return
            var $sidebarMenu = $('.sidebar-menu');
            var $sidebarMenuItems = $sidebarMenu.find('.menu-item-lvl-1');
            var $secondLevelWrapper = $sidebarMenu.find('.menu-item-lvl-1 > .menu-lvl-wrp');
            var subNavItemHovered = false;
            var hoverTimeout;
            var removeHoverTimeout;
            var timeout = 200;
            var hoverFirstLevelClass = 'has-childs-hover';
            var hoverSecondLevelClass = 'hovered';
            var disabledClass = 'menu-item_disabled';

            $secondLevelWrapper.hover(
                function () {
                    $(this).addClass(hoverSecondLevelClass);
                    subNavItemHovered = true;
                },
                function () {
                    $(this).removeClass(hoverSecondLevelClass);
                    subNavItemHovered = false;
                }
            );

            $sidebarMenuItems.hover(function () {
                XPortal.Sidebar.calculateSideBarTransform(this);
                var $currentItem = $(this);
                var hasChild = $currentItem.hasClass('has-childs') || $currentItem.find("ul.initialized").length > 0;
                clearTimeout(hoverTimeout);

                hoverTimeout = setTimeout(function () {
                    if (hasChild) {
                        $currentItem.addClass(hoverFirstLevelClass);
                    }
                    if (subNavItemHovered) {
                        $sidebarMenuItems.not($currentItem).addClass(disabledClass);
                    }
                }, timeout);
            },
                function () {
                    clearTimeout(removeHoverTimeout);
                    var $currentItem = $(this);
                    removeHoverTimeout = setTimeout(function () {
                        if (!$currentItem.find('.menu-lvl-wrp').hasClass(hoverSecondLevelClass) && !subNavItemHovered) {
                            $currentItem.removeClass(hoverFirstLevelClass);
                            $sidebarMenuItems.removeClass(hoverFirstLevelClass);
                            $sidebarMenuItems.removeClass(disabledClass);
                        }
                    }, timeout);
                }
            );
        },
    };

    return self;
}());
